import React from "react";
import { useHistory } from "react-router-dom";
import algoliasearch from "algoliasearch/lite";

import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Avatar from "@material-ui/core/Avatar";

import { SearchArea } from "../Utilities/SearchArea";
import { ScoreView } from "../Utilities/ScoreView";
import { Activity } from "../Types/types";

const client = algoliasearch("V7NYNJIM7C", "439a81efb8f918ee5bf3b0380b0f9f28");

export interface Country {
  objectID: string;
  nationality: string;
  clean_nationality: string;
  score: number;
  word_cloud: string;
}

export const CountryView = () => {
  const [index] = React.useState(client.initIndex("countries"));

  const [currentQuery, setCurrentQuery] = React.useState<string>("");
  const [currentHits, setCurrentHits] = React.useState<Country[]>([]);

  const submitSearch = async () => {
    const searchResults = await index.search(currentQuery);
    setCurrentHits(searchResults.hits as Country[]);
  };

  React.useEffect(() => {
    submitSearch();
  }, []);

  return (
    <Container maxWidth={false}>
      <SearchArea
        currentQuery={currentQuery}
        setCurrentQuery={setCurrentQuery}
        onClick={submitSearch}
      />
      <ListArea countryList={currentHits} />
    </Container>
  );
};

const ListArea: React.FC<{ countryList: Country[] }> = ({ countryList }) => {
  return (
    <section>
      {countryList.map((country) => (
        <CountryListItem key={country.objectID} country={country} />
      ))}
    </section>
  );
};

export const normaliseCountryScore = (value: number) =>
  ((value - 0) * 100) / (352 - 0);

const CountryListItem: React.FC<{ country: Country }> = ({ country }) => {
  const history = useHistory();

  return (
    <Card
      style={{ marginBottom: "20px" }}
      onClick={() => {
        history.push(`/country/${country.objectID}`);
      }}
    >
      <CardContent>
        <Grid container direction="row">
          <Grid item style={{ marginRight: "10px" }}>
            <div
              style={{
                height: "75px",
                width: "75px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography variant="h4">
                {countryToEmoji(country.clean_nationality)}
              </Typography>
            </div>
          </Grid>
          <Grid item xs={true}>
            <Typography variant="h5" gutterBottom>
              {country.clean_nationality}
            </Typography>

            <ScoreView
              score={country.score}
              scoreNormalised={normaliseCountryScore(country.score)}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export const countryToEmoji = (countryName: string) => {
  switch (countryName) {
    case "Denmark":
      return "🇩🇰";
    case "Slovenia":
      return "🇸🇮";
    case "Slovakia":
      return "🇸🇰";
    case "Malta":
      return "🇲🇹";
    case "Spain":
      return "🇪🇸";
    case "Luxembourg":
      return "🇱🇺";
    case "Estonia":
      return "🇪🇪";
    case "Latvia":
      return "🇱🇻";
    case "Czechia":
      return "🇨🇿";
    case "Romania":
      return "🇷🇴";
    case "Netherlands":
      return "🇳🇱";
    case "Bulgaria":
      return "🇧🇬";
    case "Portugal":
      return "🇵🇹";
    case "Germany":
      return "🇩🇪";
    case "Hungary":
      return "🇭🇺";
    case "France":
      return "🇫🇷";
    case "Sweden":
      return "🇸🇪";
    case "Belgium":
      return "🇧🇪";
    case "Poland":
      return "🇵🇱";
    case "Ireland":
      return "🇮🇪";
    default:
      return "🇪🇺";
  }
};
